// extracted by mini-css-extract-plugin
export var black = "_2n-6";
export var brand = "_2n-1";
export var ddefault = "_2n-0";
export var error = "_2n-3";
export var gray = "_2n-2";
export var highContrast = "_2n-8";
export var outline = "_2n-7";
export var success = "_2n-5";
export var warning = "_2n-4";